import { render, staticRenderFns } from "./ModalSectionMenuContent.vue?vue&type=template&id=20de17fd"
import script from "./ModalSectionMenuContent.vue?vue&type=script&lang=js"
export * from "./ModalSectionMenuContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports